<ng-container *ngIf="toast">
  <div class="toast-overlay">
    <div
      class="toast-box"
      [style.--fadeMs.ms]="fadeMs"
      [style.--holdMs.ms]="holdMs"
      role="status"
      aria-live="polite"
    >
      <div class="toast-title">{{ toast.title }}</div>
      <div class="toast-content">{{ toast.message }}</div>
    </div>
  </div>
</ng-container>
